export default "__VITE_ASSET__27a09fea__"